import router from './index'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import { getAppTitle } from '@/utils/common'
import useStore from '@/store'
import { flatRoutes } from '@/utils/create-router'
import { toast } from '@/utils/message'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  const store = useStore()
  NProgress.start()

  document.title = getAppTitle(to.meta.title as string)

  const hasToken = getToken()

  if (hasToken) {    
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // 根据用户信息是否存在 判断用户是否已登录
      const login = store.user.profile
      if (login) {
        next()
      } else {
        try {
          const { menus } = await store.user.getMyInfo()
          const accessRoutes = await store.permission.generateRoutes(menus)
          flatRoutes(accessRoutes).forEach(route => {
            router.addRoute(route)
          })
          next({ ...to, replace: true })
        } catch (error) {
          await store.user.resetToken()
          toast.error(error+'' || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
